import { Pipe, PipeTransform } from '@angular/core';

/**
 * Pipe to shorten a given text string to a given length
 * and replace the cutted part by ellipsis [...]
 * @class EllipsisPipe
 * @typedef {EllipsisPipe}
 * @implements {PipeTransform}
 */
@Pipe( {
    name: 'ellipsis',
    standalone: true,
    pure: true
} )
export class EllipsisPipe implements PipeTransform {
    /**
     * helper function to shorten a given text string to a given length
     * @param {string} text string to be shortend
     * @param {number} length number of character text should be shortend
     * @returns {string} shortend text with ellipsis (...) appended
     */
    transform( text: string, length: number ) {
        if ( text.length > length ) {
            return text.substring( 0, length ) + '...';
        } else {
            return text;
        }
    }
}
